import { render, staticRenderFns } from "./LanguageProficiencySpeak.vue?vue&type=template&id=78514d51&"
import script from "./LanguageProficiencySpeak.vue?vue&type=script&lang=js&"
export * from "./LanguageProficiencySpeak.vue?vue&type=script&lang=js&"
import style0 from "./LanguageProficiencySpeak.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports